import { render } from "./result-confirm.vue?vue&type=template&id=31299b0e&scoped=true&ts=true"
import script from "./result-confirm.vue?vue&type=script&lang=ts"
export * from "./result-confirm.vue?vue&type=script&lang=ts"

import "./result-confirm.vue?vue&type=style&index=0&id=31299b0e&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31299b0e"]])

export default __exports__